var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 341,
    height: 34,
    viewBox: "0 0 341 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1789",
    "data-name": "Groupe 1789",
    transform: "translate(15 -205)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Ligne_2",
    "data-name": "Ligne 2",
    x2: 306.863,
    transform: "translate(2.354 221.646)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1610",
    "data-name": "Groupe 1610",
    transform: "translate(-15 205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_250",
    "data-name": "Rectangle 250",
    fill: "#f7c030",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Bienvenue_sur_Quicks",
    "data-name": "Bienvenue sur Quicks",
    d: "M10.582,15.089V7.26H8.733V5.59h3.825v9.5Z",
    transform: "translate(5.953 6.161)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1611",
    "data-name": "Groupe 1611",
    transform: "translate(36.096 205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_250-2",
    "data-name": "Rectangle 250",
    fill: "#e0df61",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1612",
    "data-name": "Groupe 1612",
    transform: "translate(87.191 205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_250-3",
    "data-name": "Rectangle 250",
    fill: "#cdd35c",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1613",
    "data-name": "Groupe 1613",
    transform: "translate(138.287 205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_250-4",
    "data-name": "Rectangle 250",
    fill: "#7ab360",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1614",
    "data-name": "Groupe 1614",
    transform: "translate(188.861 205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_250-5",
    "data-name": "Rectangle 250",
    fill: "#4aa35b",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1615",
    "data-name": "Groupe 1615",
    transform: "translate(240.478 205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_250-6",
    "data-name": "Rectangle 250",
    fill: "#818b8e",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1616",
    "data-name": "Groupe 1616",
    transform: "translate(292 205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_250-7",
    "data-name": "Rectangle 250",
    fill: "#818b8e",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Bienvenue_sur_Quicks-2",
    "data-name": "Bienvenue sur Quicks",
    d: "M7.366,15.026V13.5l2.55-2.627q.752-.778,1.141-1.23a3.744,3.744,0,0,0,.535-.759,1.381,1.381,0,0,0,.147-.6,1.043,1.043,0,0,0-.338-.822,1.231,1.231,0,0,0-.848-.3,1.532,1.532,0,0,0-.931.3,1.724,1.724,0,0,0-.6.912L7.3,7.809a2.75,2.75,0,0,1,.637-1.288,3.3,3.3,0,0,1,1.173-.848,3.573,3.573,0,0,1,1.441-.3,3.9,3.9,0,0,1,1.658.332,2.607,2.607,0,0,1,1.109.931,2.488,2.488,0,0,1,.4,1.4,2.908,2.908,0,0,1-.179,1,4.116,4.116,0,0,1-.542.995,9.76,9.76,0,0,1-.937,1.09l-2.18,2.244H13.8v1.658Z",
    transform: "translate(43.491 211.224)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Bienvenue_sur_Quicks-3",
    "data-name": "Bienvenue sur Quicks",
    d: "M10.357,15.242a3.849,3.849,0,0,1-1.5-.3,3.373,3.373,0,0,1-1.211-.848,2.792,2.792,0,0,1-.663-1.288l1.747-.586a1.9,1.9,0,0,0,.637.924,1.622,1.622,0,0,0,.995.312,1.712,1.712,0,0,0,.81-.178,1.313,1.313,0,0,0,.529-.5,1.469,1.469,0,0,0,.191-.759,1.438,1.438,0,0,0-.185-.746,1.254,1.254,0,0,0-.523-.485,1.8,1.8,0,0,0-.822-.172,2.524,2.524,0,0,0-.561.064,2.253,2.253,0,0,0-.51.179L8.827,9.9l2.435-2.652H7.552V5.59h5.929V7.12l-2.5,2.843.064-.8a3.01,3.01,0,0,1,1.485.351,2.491,2.491,0,0,1,.982.975,2.92,2.92,0,0,1,.351,1.453,3.191,3.191,0,0,1-.459,1.7,3.239,3.239,0,0,1-1.25,1.179A3.721,3.721,0,0,1,10.357,15.242Z",
    transform: "translate(94.528 211.161)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Bienvenue_sur_Quicks-4",
    "data-name": "Bienvenue sur Quicks",
    d: "M10.825,15.089v-2.04H6.618V11.391l4.08-5.8h2.1v5.8h1.466v1.658H12.8v2.04ZM8.059,12.105l-.37-.714h3.137V7.12l.5.153Z",
    transform: "translate(144.697 211.161)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Bienvenue_sur_Quicks-5",
    "data-name": "Bienvenue sur Quicks",
    d: "M10.424,15.242a3.8,3.8,0,0,1-1.453-.287,3.375,3.375,0,0,1-1.2-.816,2.576,2.576,0,0,1-.65-1.269l1.747-.587a1.6,1.6,0,0,0,.612.892,1.663,1.663,0,0,0,.944.28,1.571,1.571,0,0,0,.778-.185,1.3,1.3,0,0,0,.516-.523,1.608,1.608,0,0,0,.185-.784,1.571,1.571,0,0,0-.185-.778,1.312,1.312,0,0,0-.516-.516,1.571,1.571,0,0,0-.778-.185,1.657,1.657,0,0,0-.816.2,1.169,1.169,0,0,0-.523.606l-1.619-.382L8.231,5.59h5.3V7.248h-4.5l.74-.893-.523,3.952-.535-.472a1.965,1.965,0,0,1,.81-.765,2.872,2.872,0,0,1,1.269-.242,3.209,3.209,0,0,1,1.645.4,2.768,2.768,0,0,1,1.065,1.1,3.4,3.4,0,0,1,.376,1.632,3.168,3.168,0,0,1-.453,1.677,3.232,3.232,0,0,1-1.23,1.173A3.621,3.621,0,0,1,10.424,15.242Z",
    transform: "translate(195.36 211.161)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.849ab0877ed39820383aac9aaf6d42cc.svg";
export { ForwardRef as ReactComponent };